import { Scene, Choice } from "../models";
import { scenes } from "../scenes";

export class MiddleManagementFloor extends Scene {
  title = "Shibari Elevator";
  get options(): any[] {
    return [
      new Choice("Enter Dareth Schamren's Office", async () => {
        await this.navigate(scenes.DarethsOffice());
      }),
      new Choice("Leave", async () => await this.navigate(scenes.Elevator())),
    ];
  }
}

export default new MiddleManagementFloor();
